export default "__VITE_ASSET__TpgnZwlG__"